module.exports = {
  login: 'Cuenta o contraseña incorrecta',
  ok: 'Operación con éxito',
  error: 'Operación fallida',
  time: 'Seleccione un intervalo de tiempo',
  empty: 'Sin datos',
  
  register: {
    ok: 'Registrado con éxito',
    error: 'El registro falló, la cuenta ya existe',
  },
  
  cex: {
    no: 'La línea está cerrada temporalmente',
    price: 'Fuera del límite de función',
    level: 'No tienes permiso aún',
    
    tool: {
      count: 'La suma de largo, ancho y alto no debe exceder a'
    }
  },
  
  user: {
    money: 'Saldo insuficiente'
  }
}